export const localeEn = {
  gloabl: {
    add: "Add",
    edit: "Edit",
    name: "Name",
    arabicName: "Arabic name",
    englishName: "English name",
    itemName: "Item name",
    address: "Address",
    arabicAddress: "Arabic address",
    englishAddress: "English address",
    image: "Image ",
    anImage: "Image",
    logo: "Logo",
    menu: "Menu",
    category: "Category",
    option: "option",
    url: "url",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    upload: "Upload",
    price: "Price",
    price_offer: "Descount price",
    offers: "Offers",
    itemProperties: "Item properties",
    description_ar: "Arabic Description",
    description_en: "English Description",
    description: "Description",
    hidden: "Hidden",
    unavailable: "unavailable",
    popular: "popular ",
    new: "New",
    option_Sets: "Options",
    options_of: "Options of",
    subOptions: "Sub Options",
    sub_option: "sub option ",
    list: "List",
    pluse: "pluse",
    mines: "minus",
    change_price: "Change price",
    field_requird: "The field is requred",
    search_to_select: "Search to Select",
    LogOut: "LogOut",
    Login: "Login",
    Username: "Username",
    username_or_phone: "Username or Phone",
    enter_username_or_phone: "Enter your username or phone number",
    user: "User",
    users: "Users",
    Password: "Password",
    chooseColor: "Choose Color",
    colorsMenu: "Colors Menu",
    primary: "Primary color",
    onPrimary: "Font color on Primary",
    secondary: "Secondary color ",
    onSecondary: "Font color on Secondary",
    enable: "Enable color ",
    disable: "Disable color",
    background: "Background color",
    onBackground: "Font color",
    socialMedia: "Social media",
    branch: "Branch",
    mobile: "Mobile",
    phone: "Phone",
    branches: "Branches",
    qrCode: "QR code",
    restaurants: "Restaurants",
    restaurant: "Restaurant",
    active: "Active",
    restaurantName: "Restaurant name",
    subOptionValue: "Value",
    yes: "Yes",
    no: "No",
    deleteMessage:
      "All items related to this item will be deleted. Do you want to delete? ",
    deleteMessage2: "Do you want to delete this item ? ",
    roulete: "Roulete",
    domin: "Domain",
    features: "Features",
    select: "Select",
    search: "Search",
    item: "Item",
    type: "Type",
    darkMode: "Dark Mode",
    defaultImage: "Default Image",
    sumVisits: "Total visits",
    apply: "Apply",
    sum: "Sum",
    from: "From",
    to: "To",
    view: "View",
    veiw: "View",
    visit: "Visit",
    visits: "Visits",
    statistics: "Statistics",
    total: "Total",
    cities: "Cities",
    countries: "Countries",
    systems: "Systems",
    OS: "OS",
    city: "City",
    country: "Country",
    scan: "Scan",
    top: "Top",
    oSystem: "Operating System",
    tenant: "Tenant",
    telegramId: "Telegram ID",
    activeOrder: "Active Orders",
    createStripeAccount: "Create Stripe Account",
    ConfigrationStripe: "Configration Stripe",
    customer: "Customer",
    customers: "Customers",
    orders: "Orders",
    addressLink: "Address Link",
    role: "Role",
    wallet: "Wallet",
    free_delivery_min_total: "Free Delivery",
    range_distance: "Distance Range",
    price_per_range: "Price Of Range",
    bonus_ratio: "bonus",
    max_points_usage_percentage: "Max Percentage Points Usage",
    hidden_status_order: "Hidden Order Status",
    logs: "Activity Logs",
    action: "Action",
    model: "Model",
    date: "Date",
    title: "Title",
    details: "Details",
    link: "Link",
    notification: "Notification",
    all: "All",
    registered: "Registered",
    guests: "Guests",
    target: "Target",
    publish: "Publish",
    branch_id: "Branch Number",
    latitude: "Latitude",
    longitude: "Longitude",
    coordinates_warning: "Important: Changing these coordinates will affect delivery fees",
    coordinates_warning_desc: "These coordinates represent the restaurant location point. Modifying them will recalculate delivery fees for all orders based on the new location.",
    status: "Status",
    order: "Order",
    payment_method: "Payment Method",
    wallet_amount: "Wallet Amount",
    table_number: "Table Number",
    time_takeaway: "Pickup Time",
    delivery_address: "Delivery Address",
    delivery_fees: "Delivery Fees",
    note: "Notes",
    created_at: "Order Date",
    order_type: "Order Type",
    order_payment_method: "Payment Method",
    update: "Update",
    total_users: "Total Users",
    active_users: "Active Users",
    today_activities: "Today Activities",
    recent_activities: "Recent Activities",
    new_order: "New Order",
    playing_notification: "Playing Notification",
    strong_alert: "Strong Alert",
    unread_orders: "Unread Orders",
    click_to_view_orders: "Click to view orders",
    enabled: "Enabled",
    disabled: "Disabled",
    copuns: "Coupons",
    copun: "Coupon",
    code: "Code",
    value: "Value",
    max_uses: "Max Uses",
    is_active: "Active",
    starts_at: "Starts At",
    expires_at: "Expires At",
    minimum_order_amount: "Minimum Order Amount",
    is_first_register: "Is First Register",

    fixed: "Fixed",
    percentage: "Percentage",
    pick_a_date: "Pick a date",
    first_register_coupon_id: "Register Coupon ",
    order_details: "Order Details",
    quantity: "Quantity",
    sub_Total: "Sub Total",
    final_total: "Final Total",
    clear: "Clear",
    used_count: "Used Count",
    remaining_uses: "Remaining Uses",
    uses: "Uses",
    start: "Start",
    end: "End",
    previous: "Previous",
    next: "Next",
    inactive: "Inactive",
    validity: "Validity",
    refund: "Refund",
    refund_amount: "Refund Amount",
    confirm: "Confirm",
    filters: "Filters",
    noData: "No data found",
    discount: "Discount",
    is_free_delivery: "Free Delivery",
    free_delivery_note:
      "When enabled, type and value become optional. You can also add a discount along with free delivery.",
    percentage_note: "Enter percentage (e.g., 10 = 10%)",
    fixed_note: "Enter fixed amount in AED",
    opening_time: "Opening Time",
    closing_time: "Closing Time",
    settings: "Settings",
    no_data: "No data found",
    select_user_and_date: "Please select a user and date range to view logs",
    table: "Table",
    yes_text: "Yes",
    no_text: "No",
    processing: "Processing...",
    coupon: "Coupon",
    select_coupon: "Select Coupon",
    payment: "Payment",
    delivary: "Delivery",
    time: "Time",
    final: "Final",
    sub_total: "Sub Total",
    free_delivery: "Free Delivery",
    day: "day",
    days: "days",
    remaining: "remaining",
    left: "left",
    expired: "Expired",
    today: "Today",
    basic_info: "Basic Information",
    basic_info_desc: "Enter the coupon code and basic details",
    discount_info: "Discount Information",
    validity_period: "Validity Period",
    additional_settings: "Additional Settings",
    optional_discount: "Optional: You can add a discount along with free delivery",
    required_discount: "Required: Select discount type and value",
    unlimited: "Leave empty for unlimited",
    no_minimum: "No minimum",
    first_register: "First Register",
    optional_description: "Optional: Add a description for this coupon",
    description_placeholder: "Enter coupon description...",
    manage_coupons: "Manage and organize your coupons",
    filter_coupons: "Filter coupons by code, status, type, or date range",
    active_filters: "Active",
    all_status: "All Status",
    all_types: "All Types",
    coupons_found: "Coupons",
    no_coupons_found: "No coupons found",
    no_coupons_description: "Try adjusting your filters or create a new coupon",
    manage_settings: "Manage and configure application settings",
    delivery_settings: "Delivery Settings",
    delivery_settings_desc: "Configure delivery options and pricing",
    points_rewards: "Points & Rewards",
    points_rewards_desc: "Manage loyalty points and bonus system",
    general_settings: "General Settings",
    general_settings_desc: "Basic application settings",
    hidden_status_order_desc: "Hide order status from customers",
    manage_notifications: "Create and manage push notifications for your users",
    notifications_found: "Notifications",
    no_notifications_found: "No notifications found",
    no_notifications_description: "Create your first notification to engage with your users",
    publish_to: "Publish To",
    content: "Content",
    content_desc: "Enter notification title and description in both languages",
    image_desc: "Upload an image for your notification (optional but recommended)",
    manage_customers: "View and manage your customers",
    customers_found: "Customers",
    no_customers_found: "No customers found",
    no_customers: "No customers yet",
    try_different_search: "Try a different search term",
    customers_will_appear: "Customers will appear here once they register",
    unknown: "Unknown",
    email: "Email",
    deleted_account: "Deleted Account",
    deleted_at: "Deleted At",
    delete_reason: "Delete Reason",
    wallet_status: "Wallet & Status",
    wallet_status_desc: "Set wallet balance and account status",
    customer_basic_info_desc: "Enter customer name and contact information",
    customer_status_desc: "Enable or disable customer account",
    discount_delivery: "Discount & Delivery",
    discount_delivery_desc: "Configure discount type, value, and free delivery option",
    usage_limits: "Usage & Limits",
    usage_limits_desc: "Set usage limits and minimum order amount",
    validity_period: "Validity Period",
    validity_period_desc: "Set when the coupon starts and expires",
    additional_options: "Additional Options",
    additional_options_desc: "Configure additional coupon settings",
    description_placeholder: "Optional description for this coupon",
    type_required: "Required when free delivery is disabled",
    unlimited: "Unlimited",
    max_uses_note: "Leave empty for unlimited uses",
    minimum_order_note: "Minimum order amount to use this coupon",
    first_register: "First Register",
    manage_social_media: "Manage your social media links and profiles",
    social_media_found: "Social Media",
    no_social_media_found: "No social media found",
    no_social_media_description: "Add your social media links to connect with your customers",
    social_media_info: "Social Media Information",
    social_media_info_desc: "Add your social media platform details",
    platform: "Platform",
    select_platform: "Choose the social media platform",
    social_media_title_desc: "Enter a name for this social media link",
    social_media_title_placeholder: "e.g., Facebook Page",
    url_must_start_with_https: "URL must start with https://",
    manage_users: "View and manage system users",
    users_found: "Users",
    no_users_found: "No users found",
    no_users_description: "Create your first user to get started",
    user_basic_info_desc: "Enter user name and contact information",
    role_permissions: "Role & Permissions",
    role_permissions_desc: "Set user role and access permissions",
    select_user_role: "Choose the user's role and permissions",
    select_user_branches: "Select branches this user can access",
    user_status_desc: "Enable or disable user account",
    password_optional_edit: "Leave empty to keep current password",
    user_name_placeholder: "Enter user name",
    phone_placeholder: "Enter phone number",
    manage_activity_logs: "View and track user activity logs",
    filter_logs: "Filter Logs",
    filter_logs_desc: "Select user and date range to view activity logs",
    date_range: "Date Range",
    logs_found: "Activity Logs",
    no_logs_found: "No logs found",
    no_logs_description: "No activity logs found for the selected user and date range",
    select_filters: "Select Filters",
    manage_branches: "View and manage restaurant branches",
    branches_found: "Branches",
    no_branches_found: "No branches found",
    no_branches_description: "Create your first branch to get started",
    branch_basic_info_desc: "Enter branch name and address in both languages",
    location_contact: "Location & Contact",
    location_contact_desc: "Set branch location and contact information",
    address_link_desc: "Google Maps link or location URL",
    image_status: "Image & Status",
    image_status_desc: "Upload branch image and set status",
    branch_status_desc: "Enable or disable branch",
    qr_code: "QR Code",
    download: "Download",
    manage_orders: "View and manage all orders",
    orders_found: "Orders",
    no_orders_found: "No orders found",
    no_orders_match_filters: "No orders match the selected filters",
    try_different_filters: "Try adjusting your filters",
    orders_will_appear: "Orders will appear here",
    filter_orders: "Filter Orders",
    filter_orders_desc: "Filter orders by payment method, type, or date",
    clear_filters: "Clear Filters",
    manage_menus_desc: "Manage and organize your restaurant menus",
    no_menus_found: "No menus found",
    menus_will_appear: "Menus will appear here once you add them",
    basic_information: "Basic Information",
    basic_information_desc: "Enter the menu name in both languages",
    image_desc_menu: "Upload a menu image (max 4MB)",
    manage_categories_desc: "Manage and organize your menu categories",
    no_categories_found: "No categories found",
    categories_will_appear: "Categories will appear here once you add them",
    select_menu_desc: "Select the menu this category belongs to",
    manage_items_desc: "Manage and organize your menu items",
    filter_items: "Filter Items",
    filter_items_desc: "Select a category to filter items",
    items_found: "Items",
    no_items_found: "No items found",
    no_items_in_category: "No items in this category",
    items_will_appear: "Items will appear here once you add them",
    select_category_desc: "Select the category this item belongs to",
    pricing: "Pricing",
    pricing_desc: "Set the item price and optional offer price",
    tags_status: "Tags & Status",
    tags_status_desc: "Configure item tags and availability status",
    image_desc_item: "Upload an item image (max 4MB)",
    manage_options_desc: "Manage item options and sub-options",
    filter_options: "Filter Options",
    filter_options_desc: "Select category and item to view options",
    options_found: "Options",
    no_options_found: "No options found",
    select_item_to_view_options: "Please select a category and item to view options",
    no_options_for_item: "No options available for this item",
    select_item_for_option_desc: "Select the category and item this option belongs to",
    sub_option_price_desc: "Set the additional price for this sub-option (0 for free)",
    no_sub_options: "No sub-options yet",
    free: "Free",
    sub_options: "Sub Options",
    manage_sort_desc: "Drag and drop items to reorder them",
    select_category: "Select Category",
    select_category_sort_desc: "Choose a category to sort its items",
    sort_instructions: "Drag items using the handle icon to reorder them. Changes are saved automatically.",
    select_category_to_sort: "Select a category to start sorting",
    select_category_first: "Please select a category from above to view and sort its items",
    no_items_to_sort: "No items to sort",
    no_items_in_category_sort: "This category doesn't have any items yet",
    welcome_back: "Welcome Back",
    login_description: "Sign in to your account to continue",
    enter_username: "Enter your username",
    login_success: "Login successful!",
    login_failed: "Login failed. Please try again.",
    login_footer: "© 2024 All rights reserved",
    page_not_found: "Page Not Found",
    page_not_found_desc: "The page you're looking for doesn't exist or has been moved.",
    go_to_branches: "Go to Branches",
    go_back: "Go Back",
    policies_and_terms: "Policies & Terms",
    policies_and_terms_desc: "Edit privacy policy and terms of service content. Basic formatting only (bold, lists, headings).",
    privacy_policy_ar_label: "Privacy Policy (Arabic)",
    privacy_policy_en_label: "Privacy Policy (English)",
    terms_of_service_ar_label: "Terms of Service (Arabic)",
    terms_of_service_en_label: "Terms of Service (English)",
    privacy_policy_placeholder_ar: "Write the Arabic privacy policy here. You can use bold text and lists.",
    privacy_policy_placeholder_en: "Write the English privacy policy here. You can use bold text and lists.",
    terms_of_service_placeholder_ar: "Write the Arabic terms of service here.",
    terms_of_service_placeholder_en: "Write the English terms of service here.",
    delivary_fees: "Delivery Fees",
    order_number: "Order Number",
    discount_value: "Discount Value",
    is_take_away_only: "Takeaway Only",
    take_away_only_note: "When enabled, this coupon applies only to takeaway orders.",
  },

  dashbord: {
    home: "Home",
    menus: "Menus",
    categories: "Categories",
    items: "Items",
    options: "Options",
    sort: "Sort",
    branches: "Branches",
    restaurants: "Restaurants",
    users: "Users",
    users_list: "Users List",
    user_activity: "User Activity",
    tenants: "Tenants",
    customers: "Customers",
    settings: "Settings",
    notifications: "Notifications",
    notification: "Notification",
    orders: "Orders",
    copuns: "Coupons",
    coupon: "Coupon",
    dashbordType: {
      0: "Menu",
      1: "Category",
      2: "Item",
      3: "option",
      4: "Sub Option",
      5: "Branch",
      6: "Restaurant",
      7: "User",
      8: "customer",
      9: "Order",
    },
  },
  orderType: {
    delivary: "Delivery",
    take_away: "Takeaway",
    dein_in: "Dine In",
  },
  paymentMethod: {
    credit: "Credit",
    cash: "Cash",
  },
  actions: {
    Add: "Add",
    Update: "Update",
    Delete: "Delete",
    Accept: "Accept",
    Cancel: "Cancel",
    Send: "Publish",
    Refunded: "Refund",
    Refund: "Refund",
    Reverse: "Refund",
  },
  models: {
    Product: "Product",
    Category: "Category",
    Option: "Option",
    SubOption: "Sub Option",
    Branch: "Branch",
    Section: "menu",
    User: "User",
    Customer: "Customer",
    Setting: "Setting",
    SocialMedia: "Social Media",
    Notification: "Notification",
    Order: "Order",
    Coupon: "Coupon",
  },
  orderStatus: {
    pending: "Pending",
    processing: "Processing",
    delivarying: "Delivarying",
    completed: "Completed",
    canseled: "Canceled",
  },
  userTypes: {
    admin: " Admin",
    data_manager: "Data manager",
    call_center: "Call center",
  },
  errorMessage: {
    fieldRequired: " is required",
    fillAll: "Please fill out all required fields",
    fieldCharsLength: `must be at least 2 characters`,
    startwith: "must start with",
    worngLogin: "Incorrect username or password. Please try again.",
    login_failed: "Login failed. Please check your credentials and try again.",
    serverError: "A server error occurred. Please try again later.",
    unauthorizedError: "You don't have permission to perform this action.",
    genericError: "An error occurred. Please try again.",

    103: "This item already exists",
    noData: "No data found",
  },
  messages: {
    imageNotSelected:
      "If no image is selected, the image of the most recently added product will be used.",

    store: " Saved successfully!",
    update: " Updated successfully!",
    delete: " Deleted successfully!",
    add: " Added successfully!",
    publish: " Notification published successfully!",
    not_found: " Data not found",
  },
};
